import Moment from 'moment';
import { extendMoment } from 'moment-range';

const moment = extendMoment(Moment);
export const sharkReportsDataBuilder = sharkReports => {
  let rounds;
  let screens;
  let roundsObject;
  const groups = formatGroupsLaunchCharts({
    filter: sharkReports.sharkGroups.filter,
    data: sharkReports.sharkAllGroups,
  });
  if (groups) {
    const allScreens = sharkReports.sharkScreens.rawData.reduce(
      (a, c) => {
        a.screens.push(c);
        a.groupIds.push(c.group_id);
        return a;
      },
      { screens: [], groupIds: [] }
    );
    const validRounds = sharkReports.sharkGroups.rawRoundsData.reduce(
      (a, c) => {
        if (allScreens.groupIds.includes(c.group_id)) {
          a.push(c);
        }
        return a;
      },
      []
    );
    roundsObject = {
      rawData: validRounds,
      filter: sharkReports.sharkGroups.filter,
    };

    const formatScreens = formatSharkScreenData(
      allScreens.screens,
      roundsObject.rawData
    );
    const screensObject = {
      rawData: formatScreens,
      filter: sharkReports.sharkGroups.filter,
    };
    rounds = formatRoundsPlayedLaunchCharts(roundsObject);
    screens = formatScreensLaunchCharts(screensObject);
  }
  return {
    rounds,
    screens,
    groups,
    roundsObject,
  };
};
export const formatSharkScreenData = (sharkScreens, sharkScreenRounds) => {
  const allCars = [];
  sharkScreens.map(car => {
    car.round_end = 0;
    car.rounds = [];

    sharkScreenRounds.map(round => {
      if (car.uuid === round.screen_id && car.round_end < round.end_time) {
        car.round_end = round.end_time;
        car.gpsi_car_id = round.gpsi_car_id;
        car.gpsi_car_number = round.gpsi_car_number;
        car.mdn = round.mdn;
        car.guid = round.guid;
        car.imei = round.imei;
        car.data_usage = round.data_usage;
        car.gpsi_course_site_id = round.gpsi_course_site_id;
        car.course_launch_intent_mode = round.course_launch_intent_mode;
        car.rounds.push(round);
      }
    });
    if (car.last_activity) {
      allCars.push(car);
    }
  });
  allCars.sort((a, b) => b.last_activity.localeCompare(a.last_activity));
  return allCars;
};

const getTimeValues = filter => {
  const newstart = moment(filter.start_date);
  const newend = moment(filter.end_date);
  const range = moment.range(newstart, newend);
  let format = 'YYYY';
  const years = Array.from(range.by('year'));
  let timeValues = years;
  let timeValue = 'y';
  if (years.length <= 2) {
    const months = Array.from(range.by('month'));
    timeValues = months;
    timeValue = 'M';
    format = 'MMMM';
    if (months.length <= 4) {
      const weeks = Array.from(range.by('week'));
      timeValues = weeks;
      timeValue = 'w';
      format = 'MM-DD';
      if (weeks.length <= 2) {
        const days = Array.from(range.by('day'));
        timeValues = days;
        timeValue = 'd';
        format = 'MM-DD';
        if (days.length <= 2) {
          const hours = Array.from(range.by('hour'));
          timeValues = hours;
          timeValue = 'h';
          format = 'HH:mm';
        }
      }
    }
  }
  return { timeValue, timeValues, format };
};
const defaultStartDate = () => moment()
  .startOf('isoWeek')
  .format('YYYY-MM-DD');
const defaultEndDate = () => moment()
  .endOf('isoWeek')
  .format('YYYY-MM-DD');
const tallyLaunchTypes = launches => {
  let bt = 0;
  let select = 0;
  let selectp = 0;
  let selectpp = 0;
  let prime = 0;
  let none = 0;
  launches.map(round => {
    switch (round.course_launch_intent_mode) {
      case 'b2b':
      case 'interface_select_bt':
        bt++;
        break;
      case 'interface_select':
        select++;
        break;
      case 'interface_select_plus':
        selectp++;
        break;
      case 'interface_select_plus_plus':
        selectpp++;
        break;
      case 'interface_prime':
        prime++;
        break;
      case null:
        none++;
        break;
    }
  });
  return {
    bt,
    select,
    selectp,
    selectpp,
    prime,
    none,
  };
};
export const formatRoundsPlayedLaunchCharts = inputData => {
  const { filter } = inputData;
  const data = inputData.rawData;
  if (!filter || !data) {
    return false;
  }
  const chart = {};
  chart.chartType = 'line';
  chart.showOnMobile = true;
  chart.type = 'line-chart';
  chart.component = 'chart';
  chart.width = '100%';
  chart.title = 'Total Rounds Played';
  chart.data = [
    {
      data: [],
      name: chart.title,
    },
  ];
  filter.start_date = filter.start_date
    ? filter.start_date
    : defaultStartDate(filter);
  filter.end_date = filter.end_date ? filter.end_date : defaultEndDate(filter);
  const { timeValue, timeValues, format } = getTimeValues(filter);
  const allRanges = [];
  timeValues.map((time, index) => {
    if (timeValues[index + 1]) {
      const range = moment.range(time, timeValues[index + 1]);
      allRanges.push(range);
    } else {
      const range = moment.range(time, moment(time).add(1, timeValue));
      allRanges.push(range);
    }
  });
  allRanges.map((range, index) => {
    chart.data[0].data[index] = 0;
    data.map(session => {
      if (range.contains(moment(session.end_time * 1000))) {
        chart.data[0].data[index] = chart.data[0].data[index] + 1;
      }
    });
  });
  const { bt, select, selectp, selectpp, prime, none } = tallyLaunchTypes(data);
  const timeLabels = timeValues.map(m => m.format(format));
  chart.labels = timeLabels;
  return {
    chart,
    data: [{ data: [prime, selectpp, selectp, select, bt, none] }],
  };
};
export const formatScreensLaunchCharts = inputData => {
  const { filter } = inputData;
  const data = inputData.rawData;
  if (!filter || !data) {
    return false;
  }

  const chart = {};
  chart.chartType = 'line';
  chart.showOnMobile = true;
  chart.type = 'line-chart';
  chart.component = 'chart';
  chart.width = '100%';
  chart.title = 'Total Golf Carts';
  chart.data = [
    {
      data: [],
      name: chart.title,
    },
  ];
  filter.start_date = filter.start_date
    ? filter.start_date
    : defaultStartDate(filter);
  filter.end_date = filter.end_date ? filter.end_date : defaultEndDate(filter);
  const { timeValue, timeValues, format } = getTimeValues(filter);
  const allRanges = [];
  timeValues.map((time, index) => {
    if (timeValues[index + 1]) {
      const range = moment.range(time, timeValues[index + 1]);
      allRanges.push(range);
    } else {
      const range = moment.range(time, moment(time).add(1, timeValue));
      allRanges.push(range);
    }
  });
  allRanges.map((range, index) => {
    chart.data[0].data[index] = 0;
    data.map(screen => {
      if (range.contains(moment(screen.last_activity * 1000))) {
        chart.data[0].data[index] = chart.data[0].data[index] + 1;
      }
    });
  });

  let bt = 0;
  let select = 0;
  let selectp = 0;
  let selectpp = 0;
  let prime = 0;
  let none = 0;
  data.map(group => {
    switch (group.launch_mode) {
      case 'b2b':
      case 'interface_select_bt':
        bt++;
        break;
      case 'interface_select':
        select++;
        break;
      case 'interface_select_plus':
        selectp++;
        break;
      case 'interface_select_plus_plus':
        selectpp++;
        break;
      case 'interface_prime':
        prime++;
        break;
      case null:
        none++;
        break;
    }
  });

  const timeLabels = timeValues.map(m => m.format(format));
  chart.labels = timeLabels;
  return {
    chart,
    data: [{ data: [prime, selectpp, selectp, select, bt, none] }],
  };
};
export const formatGroupsLaunchCharts = inputData => {
  const { filter } = inputData;
  const { data } = inputData;
  if (!filter || !data) {
    return false;
  }
  const chart = {};
  chart.chartType = 'line';
  chart.showOnMobile = true;
  chart.type = 'line-chart';
  chart.component = 'chart';
  chart.width = '100%';
  chart.title = 'Total Golf Carts';
  chart.data = [
    {
      data: [],
      name: chart.title,
    },
  ];
  // filterDates
  const { timeValue, timeValues, format } = getTimeValues(filter);
  const allRanges = [];
  timeValues.map((time, index) => {
    if (timeValues[index + 1]) {
      const range = moment.range(time, timeValues[index + 1]);
      allRanges.push(range);
    } else {
      const range = moment.range(time, moment(time).add(1, timeValue));
      allRanges.push(range);
    }
  });
  allRanges.map((range, index) => {
    chart.data[0].data[index] = 0;
    data.map(group => {
      if (range.contains(moment(group.last_activity))) {
        chart.data[0].data[index] = chart.data[0].data[index] + 1;
      }
    });
  });
  let bt = 0;
  let select = 0;
  let selectp = 0;
  let selectpp = 0;
  let prime = 0;
  let none = 0;
  data.map(group => {
    switch (group.launch_mode) {
      case 'b2b':
      case 'interface_select_bt':
        bt++;
        break;
      case 'interface_select':
        select++;
        break;
      case 'interface_select_plus':
        selectp++;
        break;
      case 'interface_select_plus_plus':
        selectpp++;
        break;
      case 'interface_prime':
        prime++;
        break;
      case null:
        none++;
        break;
    }
  });
  const timeLabels = timeValues.map(m => m.format(format));
  chart.labels = timeLabels;
  return {
    chart,
    data: [{ data: [prime, selectpp, selectp, select, bt, none] }],
  };
};
